import "./index.style.css";
import React, { useContext } from "react";
import { useLocation } from "react-router-dom";
import { Layout, Button, Popover } from "antd";
import LanguageSwitcher from "../LanguageSwitcher";
import { getText } from "../configure/utils";
import { LanguageContext } from "../../context/LanguageContext";
import { useAuth } from "../msalAuth/AuthProvider";

import signout from "../../assets/signon/signout.png";

const { Header: AntHeader } = Layout;

function Header() {
  useContext(LanguageContext);
  const { logout, logoutWithNoRedirect, user } = useAuth();
  const userEmail = user?.username || "";
  const { pathname } = useLocation();

  const handleLogout = () => {
    if (pathname === "/walkincenter") {
      console.log("wk");
      logoutWithNoRedirect();
      return;
    }
    logout();
  };

  return (
    <AntHeader className="header">
      <div className="header-left">
        <div className="logo">
          <h1>{getText("header.welcome")}</h1>
        </div>
        <div className="logo1">
          <h1>{getText("header.welcome1")}</h1>
        </div>
      </div>

      <div className="header-right">
        <div className="text-email">{userEmail ? `${userEmail}` : ""}</div>
        <LanguageSwitcher />
        {userEmail && (
          // <Button onClick={handleLogout} danger>
          //   {getText("header.logout")}
          // </Button>
          <Popover placement="bottomRight" title={getText("header.logout")} overlayClassName="header-popover">
            <Button onClick={handleLogout} shape="circle" icon={<img src={signout} alt="signout" width={30} />} style={{ border: "none" }}></Button>
          </Popover>
        )}
      </div>
    </AntHeader>
  );
}

export default Header;
